<template>
  <template v-if="selectedIds.length === 0">
    <p
      class="mb-4 py-1 text-center text-sm text-background-fg/87"
    >
      No modifiers set on this product, click below to add
      modifiers
    </p>
  </template>
  <!-- @vue-ignore -->
  <VDraggable
    v-model="fieldModel"
    item-key="key"
    handle="[data-handle]"
    tag="ol"
    v-bind="dragOptions"
  >
    <template #item="{ element, index }">
      <li class="">
        <div
          class="flex items-center justify-between space-x-2 bg-background"
        >
          <div>
            <button
              type="button"
              data-handle
              class="cursor-grab"
            >
              <IconThreeBars class="size-5 text-gray-400" />
            </button>
          </div>
          <ProductModifierGroupInfoCard
            :product-modifier-group-id="element.value"
          />
          <button
            class="flex items-center justify-center"
            @click="remove(index)"
          >
            <IconMinus />
          </button>
        </div>
      </li>
    </template>
  </VDraggable>

  <div class="flex justify-around">
    <ButtonAdd @click="onAddProductModifierGroup">
      Add Modifier
    </ButtonAdd>
  </div>

  <ProductModifierGroupDialog
    ref="productModifierGroupDialogRef"
    :selected-group-ids="selectedIds"
    @push="push"
    @remove="removeByValue"
  />
</template>

<script setup lang="ts">
import VDraggable from "vuedraggable"

const $style = useCssModule()
const props = defineProps<{
  name: string
  label: string
}>()
const { fields, push, remove, removeByValue, replace } =
  useUniqueFieldArray<string>(toRef(props, "name"))

const fieldModel = computed({
  get: () => fields.value,
  set: (newFields) => {
    replace(newFields.map(({ value }) => value))
  },
})
const selectedIds = computed(() =>
  fields.value.map(({ value }) => value)
)

const productModifierGroupDialogRef = useTemplateRef(
  "productModifierGroupDialogRef"
)
const onAddProductModifierGroup = async () => {
  if (!productModifierGroupDialogRef.value) return
  await productModifierGroupDialogRef.value.reveal()
}

const dragOptions = computed(() => ({
  animation: 200,
  ghostClass: $style.ghost,
  dragClass: $style.drag,
  direction: "vertical",
}))
</script>

<style lang="scss" module>
.ghost {
  opacity: 0;
}

.drag {
  opacity: 1;
}
</style>
